import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {TerroristFile} from '../../model';
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {ActivatedRoute, Router} from "@angular/router";
import {AlertPanelComponent, AlertPanelService, AlertService} from "@amlCore/components";
import {AccessJson, FromuFilter, TerroristFilter} from "@amlCore/models";
import {CheckDictEnum, RegistriesAccessEnum} from "@amlCore/enums";
import {Utils} from "@amlCore/utils";
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from "@amlCore/services";
import {Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {DictImportResult} from "../../model/dictImportResult.model";
import {AlertModalComponent, ConfirmComponent, InputFileComponent} from "../../../core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";


@Component({
  selector: 'app-registry-terrorist-list-file',
  templateUrl: './terroristFile.component.html'
})
export class TerroristFileComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  $destroy = new Subject();

  constructor(private regSrv: RegistriesService,
              private alertSrv: AlertService,
              private resourceSrv: ResourceService,
              private userSrv: UserService,
              private readonly modalService: NgbModal,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router,
              protected alertPanelSrv: AlertPanelService) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'sysRegData', dir: 'DESC'});
  }

  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;
  public terroristFiles: Array<TerroristFile> = [];
  public loadCheckList = {};
  private access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_TERROR);
    this.activatedRoute.queryParams
        .pipe(takeUntil(this.$destroy))
        .subscribe((data : FromuFilter) => {
          this.loadList(this.syncParams(data));
    });
  }

  //обработка результата импорта
  public onAfterImport(result: any) {
    const data = result.data as DictImportResult;
    let comp = result.comp as InputFileComponent;
    let event = result.event;
    if(!data?.success){
      if(data?.needConfirm){
        const modal = this.modalService.open(ConfirmComponent);
        modal.componentInstance.title = "Внимание";
        modal.componentInstance.text = `${data.error} Продолжить импорт?`;
        modal.componentInstance.okBtn = "Да";
        modal.componentInstance.cancelBtn = "Нет";
        modal.componentInstance.hideCloseBtn = true;
        modal.result.then(() => {
          comp.queryParams = comp.queryParams.set("force", "true");
          comp.sendFiles(event.target.files, event, true);
        }, cancel => {
          comp.reset();
        });
      } else {
        comp.reset();
        this.alertObjToCheck.open(this.alertPanelSrv.getErrorMsg(data.error, true, 10000));
      }
    } else {
      comp.reset();
      this.loadList();
      this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
        `Импортирован справочник ${data.fileName}, импортировано записей ${data.count}.`, true, 10000));

    }
  }

  public loadList(params?: TerroristFilter) {
    const queryParams = this.getParams(params);
    this.resourceSrv.getTerroristFiles(queryParams)
        .pipe(takeUntil(this.$destroy))
        .subscribe(data => {
          this.terroristFiles = data.content;
          this.total = data.totalSize;
          this.scrollRun();
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params) {
    this.navigate({...params, ...this.getParams(this.filter)});
  }

  /**
   * Метод переходна на список террористов.
   */
  public navigateToTerroristList(terrorist: TerroristFile) {
    if(this.isRowInactive(terrorist)) {
      const modal = this.modalService.open(AlertModalComponent);
      modal.componentInstance.text = "Просмотр списка фигурантов перечня возможен только по действующему (последнему загруженному) перечню";
      return;
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/terroristList', terrorist.id]);
  }

  // @override
  public onSearch() {
    this._customSearch();
  }

  // @override
  public onFilter() {
    this._customSearch();
  }

  private _customSearch(): void {
    const params = this.getSearchPage(this.filter) as TerroristFilter;
    params['dir'] = 'ASC';
    params['sort'] = 'name';
    params['isAll'] = true;
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigateByUrl('/registries/terroristListAll?q=' + Utils.encodeJSONBase64(urlParam));
  }

  public remove(confirm, terr: TerroristFile) {
    this.regSrv.deleteFile(`/api/v1/cls/extter/terror/remove?id=${terr.id}`)
      .pipe(takeUntil(this.$destroy))
      .subscribe(data => {
        this.alertObjToCheck.open(this.alertPanelSrv.getSuccessMsg(
          `Запись ${terr.fileName} удалена!`, true, 10000));
        this.loadList();
    });
  }

  /**
   * Проверка по факторам риска
   * @param terr - элемент проверки
   */
  public checkRiskFactor(terr: TerroristFile) {
    this.regSrv.doCheckRiskFactor(terr, CheckDictEnum.TERROR, this.loadCheckList, this.alertObjToCheck, this.afterCheck.bind(this));
  }

  private afterCheck(item: TerroristFile, data: any): void {
    if(data.checkDate) {
      const lastCheckedItem = this.terroristFiles.find(d => d.lastChecked && d.id != item.id);
      if(lastCheckedItem){
        lastCheckedItem.lastChecked = false;
      }
    }
  }

  public checkAccess() {
    return this.access.readOnly;
  }

  isRowInactive(item: TerroristFile): boolean{
    return !item.isActual && !item.lastChecked;
  }

  ngOnDestroy() {
    this.checkScrollOptions();
    this.$destroy.next();
    this.$destroy.complete();
  }

}
